import QueryString from 'qs';
import { HttpHandle } from '../HttpHandle';

export class GenericService<T> {
  private httpHandle = HttpHandle.getInstance();
  private uri: string = "";

  protected setUri(uri: string) {
    this.uri = uri;
  }

  public get<H>() {
    return this.httpHandle.getAxios().get<H>(this.uri);
  }

  public getByPath<H>(path: string) {
    return this.httpHandle.getAxios().get<H>(`${this.uri}/${path}`);
  }

  public getByResource<H>(resource: string, params?: any) {
    return this.httpHandle.getAxios().get<H>(`${this.uri}/${resource}`, {
      params: params,
      paramsSerializer: QueryString.stringify,
    });
  }

  public post<H>(body: T) {
    return this.httpHandle.getAxios().post<H>(`${this.uri}`, body);
  }

  public postByResource<H>(body: T, resource = "") {
    return this.httpHandle.getAxios().post<H>(`${this.uri}/${resource}`, body);
  }

  public postByResourceWithConfig<H>(body: T, resource = "", config = {}) {
    return this.httpHandle.getAxios().post<H>(`${this.uri}/${resource}`, body, config);
  }

  public postByResourceHeaders(body: T, resource?: string): Promise<T[]> {
    return this.httpHandle.getAxios().post(`${this.uri}/${resource}`, body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  public postByResourceHeadersTwo(body: T, id?: string, resource?: string): Promise<T[]> {
    return this.httpHandle.getAxios().post(`${this.uri}/${resource}`, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        "EmpresaId": `${id}`
      }
    });
  }

  public postByResourceHeadersPDF(body: T, resource?: string): Promise<T[]> {
    return this.httpHandle.getAxios().post(`${this.uri}/${resource}`, body, {
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: "blob"
    });
  }

  public getByResourceBlob(resource: string) {
    return this.httpHandle.getAxios().get(`${this.uri}/${resource}`, {
      responseType: 'blob'
    });
  }

  public put<H>(body: T) {
    return this.httpHandle.getAxios().put<H>(this.uri, body);
  }

  public putByResource<H>(body: T, resource?: string) {
    return this.httpHandle.getAxios().put<H>(`${this.uri}/${resource}`, body);
  }

  public patch<H>(body: T) {
    return this.httpHandle.getAxios().patch<H>(this.uri, body);
  }

  public patchByResource<H>(body: T, resource?: string) {
    return this.httpHandle.getAxios().patch<H>(`${this.uri}/${resource}`, body);
  }
  public getByResourcepPhoto(resource: string, params?: any): Promise<T[]> {
    return this.httpHandle.getAxios().get(`${this.uri}/${resource}`, {
      params: params,
      responseType: 'arraybuffer',
      paramsSerializer: QueryString.stringify
    });
  }

  public deleteByResource(body: T, resource?: string): Promise<T[]> {
    return this.httpHandle.getAxios().delete(`${this.uri}/${resource}`);
  }

  public getLastProntuario<H>(path: string) {
    return this.httpHandle.getAxios().get<H>(`${this.uri}/${path}`);
  }
}
